import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useAuthStore from "../store/useAuthStore";
import logo from "../assets/images/logo.webp";
import login_bg from "../assets/images/forgot_bg.png";

const ResetPassword: React.FC = () => {
  const { resetPassword, error, successMessage, setSuccessMessage, isLoading } = useAuthStore();
  const { token } = useParams<{ token: string }>();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // NEW: visibility toggles
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((s) => !s);
  const toggleConfirmVisibility = () => setShowConfirm((s) => !s);

  useEffect(() => {
    window.scrollTo(0, 0);
    setSuccessMessage("");
  }, [setSuccessMessage]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token || !password || !confirmPassword) {
      useAuthStore.setState({ error: "All fields are required!" });
      return;
    }
    await resetPassword(token, password, confirmPassword);
  };

  return (
    <>
      <nav className="mainHeader navbar navbar-expand-lg navbar-light border-bottom">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img src={logo} alt="logo" className="img-fluid" />
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse customNav" id="navbarNav">
            <div className="d-flex ms-auto align-items-center auth_wrapper">
              <Link to="/signup">
                <button className="btn btn-outline-primary">Join Now For Free</button>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <section className="auth_hero_wrapper position-relative bg-light pt-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 pe-0">
              <div className="auth_hero_inner_img" style={{ backgroundImage: `url(${login_bg})` }}></div>
            </div>

            {successMessage ? (
              <div className="col-lg-5 ps-lg-0 offset-lg-1">
                <div className="auth_caption">
                  <h2 className="text-dark mb-4">Password Reset Successful</h2>
                  <div className="my-4 border-bottom"></div>
                  <h5 className="mb-4">
                    Your password has been reset successfully. You can now log in with your new password.
                  </h5>
                  <Link to="/login">
                    <button className="btn btn-primary w-100">Return to Sign In</button>
                  </Link>
                </div>
              </div>
            ) : (
              <div className="col-lg-5 ps-lg-0 offset-lg-1">
                <div className="auth_caption">
                  <h2 className="text-dark mb-4">Reset Your Password</h2>
                  <div className="my-4 border-bottom"></div>
                  <h5 className="mb-4">Enter your new password below.</h5>

                  <form className="auth_form mb-4" onSubmit={handleSubmit}>
                    {/* New Password with eye icon */}
                    <div className="mb-3">
                      <div className="form_field_right_icon form_field_right_icon_login position-relative">
                        <input
                          className="form-control pe-5"
                          type={showPassword ? "text" : "password"}
                          placeholder="New Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          autoComplete="new-password"
                          aria-label="New Password"
                        />
                        <i
                          className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                          onClick={togglePasswordVisibility}
                          role="button"
                          aria-label={showPassword ? "Hide password" : "Show password"}
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            right: "25px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#6c757d"
                          }}
                        ></i>
                      </div>
                    </div>

                    {/* Confirm Password with eye icon */}
                    <div className="mb-3">
                      <div className="form_field_right_icon form_field_right_icon_login position-relative">
                        <input
                          className="form-control pe-5"
                          type={showConfirm ? "text" : "password"}
                          placeholder="Confirm Password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          autoComplete="new-password"
                          aria-label="Confirm Password"
                        />
                        <i
                          className={`fa-solid ${showConfirm ? "fa-eye-slash" : "fa-eye"}`}
                          onClick={toggleConfirmVisibility}
                          role="button"
                          aria-label={showConfirm ? "Hide confirm password" : "Show confirm password"}
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            right: "25px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#6c757d"
                          }}
                        ></i>
                      </div>
                    </div>

                    {error && <p style={{ color: "red" }}>{error}</p>}
                    {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}

                    <button type="submit" className="btn btn-primary w-100">
                      {isLoading ? "Resetting..." : "Reset Password"}
                    </button>
                  </form>

                  <div className="text-center mt-4">
                    <Link to="/login" className="text-decoration-none text-dark font600">
                      <i className="fa-solid fa-arrow-left me-2"></i> Back to Sign in
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ResetPassword;
